import { motion } from "motion/react";
import { cn } from "@babackapp/customer-ui/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

const widgetPageVariants = cva("flex flex-col gap-10 w-full flex-1 min-h-0 pt-20", {
  variants: {
    variant: {
      default: "",
      centered: "justify-center flex h-full -pt-24",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export function WidgetPage({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof motion.div> &
  VariantProps<typeof widgetPageVariants>) {
  return (
    <motion.div
      className={cn(widgetPageVariants({ variant, className }), className)}
      {...props}
    />
  );
}
